import { getAfUrl } from 'Cloud/Application/Editor/MyOffice/helpers/downloadDocument';
import { aiRmvBgrndNoLimit, imgRemoveBackgroundModel } from 'reactApp/appHelpers/featuresHelpers/features/imageTools';
import { ConnectionError } from 'reactApp/errors';
import { improveImageError, improveImageSuccess } from 'reactApp/modules/aiTools/aiTools.module';
import { getAiRmvBgrndAvailableAttempts, getAiToolsRmvBgrndStartTime } from 'reactApp/modules/aiTools/aiTools.selectors';
import {
    type AiImageImproveData,
    type IImageProcessor,
    type ImageProcessRequestData,
    aiRmvBgrndLocalStorageKey,
} from 'reactApp/modules/aiTools/aiTools.types';
import { aiBckgrRmvDebugLogger } from 'reactApp/modules/aiTools/helpers/ImageTools.helpers';
import { sendErrorRadar } from 'reactApp/modules/aiTools/helpers/SendErrorRadar';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SNACKBAR_CLOSE_TIMEOUT_LOW } from 'reactApp/modules/snackbar/snackbar.constants';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { getStorageItemById } from 'reactApp/modules/storage/storage.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { saveDataToStorage } from 'reactApp/storage';
import { sendXray } from 'reactApp/utils/ga';
import { put, select } from 'typed-redux-saga';

let imageProcessor: IImageProcessor | null = null;

function* handleError(payload: ImageProcessRequestData, error: any = null) {
    yield put(improveImageError(payload));

    sendXray('ai-bkgrnd-rmv-img-error');

    sendErrorRadar('rmback', error?.message);

    let text = 'Не удалось удалить фон';

    if (error && error instanceof ConnectionError) {
        text = 'Не удалось удалить фон — нет интернета';
    }

    yield put(
        showSnackbarAction({
            id: 'imageRmvBgrError',
            type: SnackbarTypes.failure,
            text,
            closable: true,
            autoWidth: true,
            closeTimeout: SNACKBAR_CLOSE_TIMEOUT_LOW,
        })
    );
}

export function* handleRemoveBackground(payload: ImageProcessRequestData) {
    try {
        if (!imageProcessor) {
            imageProcessor = (yield import(/* webpackChunkName: "imageTools" */ 'reactApp/modules/aiTools/ImageProcessor')).imageProcessor;
        }
        const inited = yield imageProcessor?.init();
        const file = yield* select(getStorageItemById, payload.storage || EStorageType.home, payload.id);

        if (!inited || !payload.storage || !file || file.isFolder) {
            yield handleError(payload);
            return;
        }

        let url = file.url?.get || file.url?.download || file.url?.view;

        const isAttach = payload.storage === EStorageType.attaches || payload.storage === EStorageType.viewerAttaches;

        if (isAttach && url) {
            url = yield getAfUrl(url);
        }

        const { imageDataUrl, buffer, error } = yield imageProcessor?.removeBackground(
            {
                ext: file.ext,
                url,
                directUrl: isAttach,
            },
            imgRemoveBackgroundModel.name,
            imgRemoveBackgroundModel.dtype
        ) || {};

        if (error) {
            yield handleError(payload, { message: error });
            return;
        }

        yield* put(improveImageSuccess({ ...payload, imageResult: imageDataUrl }));

        if (!aiRmvBgrndNoLimit) {
            const startTime = yield select(getAiToolsRmvBgrndStartTime);
            const attemptsAvailable = yield select(getAiRmvBgrndAvailableAttempts);
            saveDataToStorage<AiImageImproveData>(aiRmvBgrndLocalStorageKey, {
                startTime,
                attemptsAvailable,
            });
        }

        yield put(
            showSnackbarAction({
                id: 'imageRmvBgrSuccess',
                type: SnackbarTypes.success,
                text: 'Фон удалён нейросетью',
                closable: true,
                autoWidth: true,
                closeTimeout: SNACKBAR_CLOSE_TIMEOUT_LOW,
            })
        );

        return buffer;
    } catch (error) {
        aiBckgrRmvDebugLogger.error('handleRemoveBackground', error);

        yield handleError(payload, error);
    }
}
